/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface Principal {
  deploymentID?: string;
  accessKey?: string;
  secretKey?: string;
}

export interface ApiError {
  message: string;
  detailedMessage: string;
}

export interface RedirectRule {
  redirect?: string;
  displayName?: string;
}

export interface User {
  id?: string;
  email?: string;
  sys_created?: string;
}

export interface AuditLog {
  uuid?: string;
  /** @format int64 */
  id?: number;
  api_name?: string;
  /** @format int64 */
  time?: number;
  api_bucket?: string;
  api_object?: string;
  api_rx?: number;
  api_tx?: number;
  api_tx_headers?: number;
  api_status_code?: number;
  remote_host?: string;
  request_id?: string;
  user_agent?: string;
  access_key?: string;
  parent_user?: string;
}

export interface AuditLogs {
  /** @format int64 */
  count?: number;
  /** @format int64 */
  last_row_time?: number;
  results?: AuditLog[];
}

export interface AuditSummary {
  /** @format int64 */
  error_count: number;
  /** @format int64 */
  get_call_count: number;
  /** @format int64 */
  put_call_count: number;
  /** @format int64 */
  post_call_count: number;
  /** @format int64 */
  list_call_count: number;
  /** @format int64 */
  delete_call_count: number;
  /** @format int64 */
  head_call_count: number;
  /** @format int64 */
  bytes_sent: number;
  /** @format int64 */
  bytes_received: number;
  /** @format int64 */
  calculated_at: number;
}

export interface ErrorLog {
  uuid?: string;
  /** @format int64 */
  id?: number;
  api_name?: string;
  /** @format int64 */
  time?: number;
  error_level?: string;
  error_kind?: string;
  error_message?: string;
  trace_message?: string;
  source?: string[];
}

export interface ErrorLogs {
  /** @format int64 */
  count?: number;
  /** @format int64 */
  last_row_time?: number;
  results?: ErrorLog[];
}

export interface ErrorLogSummary {
  /** @format int64 */
  error_count: number;
  /** @format int64 */
  calculated_at: number;
}

export interface Deployment {
  id?: string;
  name?: string;
  url?: string;
  access_key?: string;
  /** @format int64 */
  sys_created?: number;
}

export interface DeploymentDetailsResponse {
  message?: string;
  details: DeploymentDetails;
}

export interface DeploymentDetails {
  id: string;
  name: string;
  url: string;
  access_key: string;
  /** @format int64 */
  sys_created: number;
  /** @format int64 */
  buckets?: number;
  /** @format int64 */
  objects?: number;
  /** @format int64 */
  usage?: number;
  /** @format int64 */
  offline_disks?: number;
  /** @format int64 */
  online_disks?: number;
  pools?: PoolDetails[];
}

export interface PoolDetails {
  /** @format int64 */
  total_drives_per_set?: number;
  /** @format int64 */
  total_sets?: number;
}

export interface DrivesMetricsResponse {
  results: DriveMetricsResult[];
}

export interface DriveMetricsResult {
  /** @format int64 */
  retrieved_at: number;
  data: Record<string, DriveMetric>;
  /** @format uint64 */
  latency_mean: number;
}

export interface DriveMetric {
  /** @format uint64 */
  count: number;
  /** @format uint64 */
  acc_time_ns: number;
  /** @format uint64 */
  bytes: number;
  online?: boolean;
  details?: Record<string, DriveMetric>;
}

export interface OutlierDriveResponse {
  results: string[];
}

export interface PrometheusMetricsResponse {
  results: PrometheusMetricsData;
}

export interface PrometheusMetricsData {
  /** @format uint32 */
  top_bottom_n_value?: number;
  retrieved_at: number[];
  top_n_metrics?: string[];
  bottom_n_metrics?: string[];
  avg_rows: number[];
  metrics: Record<string, PrometheusMetricLabelData>;
}

export interface PrometheusMetricLabelData {
  /** @format int64 */
  avg: number;
  data: number[];
}

export interface PrometheusTopBottomAvgMetricResponse {
  retrieved_at: number[];
  top_1: PrometheusMetricData;
  bottom_1: PrometheusMetricData;
  avg: PrometheusMetricData;
}

export interface PrometheusMetricData {
  key?: string;
  data?: number[];
  /** @format uint64 */
  instantValue?: number;
}

export interface PrometheusTopBottomValuesResponse {
  top_labels: PrometheusSingleMetricValue[];
  bottom_labels: PrometheusSingleMetricValue[];
}

export interface PrometheusAggregateResponse {
  aggregate: PrometheusMetricData;
  retrieved_at: number[];
}

export interface PrometheusSingleMetricValue {
  key: string;
  /** @format uint64 */
  value: number;
}

export interface CreateDeployment {
  deployment?: Deployment;
  secret_key?: string;
}

export interface Deployments {
  /** @format int64 */
  count?: number;
  results?: DeploymentDetailsResponse[];
}

export type Id = string;

export interface Warnings {
  /** @format int64 */
  count: number;
  results: Warning[];
}

export interface Warning {
  id: string;
  encodedId: string;
  /** @format int64 */
  timestamp: number;
  type: "disk";
  message: string;
  /** @format int32 */
  priority: number;
  server: string;
}

export interface AnalyticsDebugReponse {
  /** @format int64 */
  minute_interval: number;
  /** @format int64 */
  sizeData: number;
  /** @format double */
  warning_threshold: number;
  metrics_analytics: MetricsAnalytics[];
}

export interface MetricsAnalytics {
  key: string;
  /** @format double */
  mean: number;
  /** @format double */
  variance: number;
  /** @format double */
  standardDeviation: number;
}

export interface XrayHealth {
  health_info?: Record<string, any>;
  /** @format int64 */
  taken_at?: number;
}

export type IngestRequest = object;

export interface DataframeRow {
  drive: string;
  /** @format int64 */
  timestamp: number;
  feature: string;
  feature_value?: number;
  eset?: string;
}

export interface DriveDetailedMetrics {
  results?: DataframeRow[];
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "/api/v1";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title MinIO Observe
 * @version 0.1.0
 * @baseUrl /api/v1
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  audit = {
    /**
     * No description
     *
     * @tags Audit
     * @name SearchAudit
     * @summary Audit Log Search
     * @request GET:/audit/search
     * @secure
     */
    searchAudit: (
      query?: {
        /** @format int64 */
        start_time?: number;
        filters?: string;
        /** @format int32 */
        limit?: number;
        /**
         * @format int32
         * @default 0
         */
        offset?: number;
        query?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AuditLogs, ApiError>({
        path: `/audit/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Audit
     * @name AuditLogSummary
     * @summary Audit Log Summary
     * @request GET:/audit/summary
     * @secure
     */
    auditLogSummary: (params: RequestParams = {}) =>
      this.request<AuditSummary, ApiError>({
        path: `/audit/summary`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  error = {
    /**
     * No description
     *
     * @tags LogError
     * @name SearchError
     * @summary Error Log Search
     * @request GET:/error/search
     * @secure
     */
    searchError: (
      query?: {
        /** @format int64 */
        start_time?: number;
        filters?: string;
        /** @format int32 */
        limit?: number;
        /**
         * @format int32
         * @default 0
         */
        offset?: number;
        query?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ErrorLogs, ApiError>({
        path: `/error/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags LogError
     * @name ErrorLogSummary
     * @summary Error Log Summary
     * @request GET:/error/summary
     * @secure
     */
    errorLogSummary: (params: RequestParams = {}) =>
      this.request<ErrorLogSummary, ApiError>({
        path: `/error/summary`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  drivesMetrics = {
    /**
     * No description
     *
     * @tags DrivesMetrics
     * @name GetDrivesMetrics
     * @summary Drives Metrics
     * @request GET:/drives-metrics
     * @secure
     */
    getDrivesMetrics: (
      query: {
        startTime: number;
        drives?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<DrivesMetricsResponse, ApiError>({
        path: `/drives-metrics`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DrivesMetrics
     * @name GetOutlierDrives
     * @summary Outlier Drives
     * @request GET:/drives-metrics/outliers
     * @secure
     */
    getOutlierDrives: (params: RequestParams = {}) =>
      this.request<OutlierDriveResponse, ApiError>({
        path: `/drives-metrics/outliers`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  driveDetailedMetrics = {
    /**
     * No description
     *
     * @tags DrivesMetrics
     * @name DriveDetailedMetrics
     * @summary Returns the detailed metrics for one or multiple drives specified by drive query param
     * @request GET:/drive-detailed-metrics
     * @secure
     */
    driveDetailedMetrics: (
      query: {
        /** @default 3600 */
        startTime?: number;
        drives: string;
        /**
         * Points Per Timestamp
         * @default 60
         */
        ppt?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<DriveDetailedMetrics, ApiError>({
        path: `/drive-detailed-metrics`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  prometheusMetrics = {
    /**
     * No description
     *
     * @tags Prometheus
     * @name GetPrometheusMetrics
     * @summary Prometheus Metrics
     * @request GET:/prometheus-metrics/{metricKey}
     * @secure
     */
    getPrometheusMetrics: (
      metricKey: string,
      query: {
        startTime: number;
        /**
         * @format int32
         * @default 5
         */
        topNLimit?: number;
        /**
         * @format int32
         * @default 5
         */
        bottomNLimit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PrometheusMetricsResponse, ApiError>({
        path: `/prometheus-metrics/${metricKey}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prometheus
     * @name GetPrometheusMetricTopBottomAvg
     * @summary Prometheus Metric Top, Bottom and Avg
     * @request GET:/prometheus-metrics/{metricKey}/top-bottom-avg
     * @secure
     */
    getPrometheusMetricTopBottomAvg: (
      metricKey: string,
      query: {
        startTime: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PrometheusTopBottomAvgMetricResponse, ApiError>({
        path: `/prometheus-metrics/${metricKey}/top-bottom-avg`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prometheus
     * @name GetPrometheusMetricTopBottomValues
     * @summary Prometheus Metric Top and Bottom values
     * @request GET:/prometheus-metrics/{metricKey}/top-bottom-values
     * @secure
     */
    getPrometheusMetricTopBottomValues: (
      metricKey: string,
      query: {
        startTime: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PrometheusTopBottomValuesResponse, ApiError>({
        path: `/prometheus-metrics/${metricKey}/top-bottom-values`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prometheus
     * @name GetPrometheusMetricAggregate
     * @summary Prometheus Metric Aggregate
     * @request GET:/prometheus-metrics/{metricKey}/aggregate
     * @secure
     */
    getPrometheusMetricAggregate: (
      metricKey: string,
      query: {
        startTime: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PrometheusAggregateResponse, ApiError>({
        path: `/prometheus-metrics/${metricKey}/aggregate`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  warnings = {
    /**
     * No description
     *
     * @tags Warnings
     * @name ListWarnings
     * @summary List Warnings
     * @request GET:/warnings
     * @secure
     */
    listWarnings: (
      query?: {
        filters?: string;
        /** @format int32 */
        limit?: number;
        /**
         * @format int32
         * @default 0
         */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<Warnings, ApiError>({
        path: `/warnings`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Warnings
     * @name DeleteAllWarning
     * @summary Delete All Warnings
     * @request DELETE:/warnings
     * @secure
     */
    deleteAllWarning: (params: RequestParams = {}) =>
      this.request<void, ApiError>({
        path: `/warnings`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Warnings
     * @name DeleteWarning
     * @summary Delete Warning
     * @request DELETE:/warnings/{warningId}
     * @secure
     */
    deleteWarning: (warningId: string, params: RequestParams = {}) =>
      this.request<void, ApiError>({
        path: `/warnings/${warningId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  analytics = {
    /**
     * No description
     *
     * @tags Analytics
     * @name DebugAnalyticsData
     * @summary Get Debug Analytics Data
     * @request GET:/analytics/debug
     * @secure
     */
    debugAnalyticsData: (params: RequestParams = {}) =>
      this.request<AnalyticsDebugReponse, ApiError>({
        path: `/analytics/debug`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  xRay = {
    /**
     * No description
     *
     * @tags XRay
     * @name XRayHealth
     * @summary Get Health Data
     * @request GET:/x-ray
     * @secure
     */
    xRayHealth: (
      query?: {
        /** @default false */
        live?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<XrayHealth, ApiError>({
        path: `/x-ray`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags XRay
     * @name DriveFeaturesDataframe
     * @summary Get Time Series data for features for Drives
     * @request GET:/x-ray/drive-features
     * @secure
     */
    driveFeaturesDataframe: (
      query?: {
        /** @default false */
        uncompressed?: boolean;
        /** @default 3600 */
        startTime?: number;
        /**
         * Points Per Timestamp
         * @default 60
         */
        ppt?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<DriveDetailedMetrics, ApiError>({
        path: `/x-ray/drive-features`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  ingest = {
    /**
     * No description
     *
     * @tags Ingest
     * @name IngestAudit
     * @summary Ingest a new file.
     * @request POST:/ingest/audit
     */
    ingestAudit: (body: IngestRequest, params: RequestParams = {}) =>
      this.request<void, ApiError>({
        path: `/ingest/audit`,
        method: "POST",
        body: body,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ingest
     * @name IngestError
     * @summary Ingest a new file.
     * @request POST:/ingest/error
     */
    ingestError: (body: IngestRequest, params: RequestParams = {}) =>
      this.request<void, ApiError>({
        path: `/ingest/error`,
        method: "POST",
        body: body,
        ...params,
      }),
  };
}
